import React from 'react';
import styled, { keyframes } from 'styled-components';
import CircularProgressWithLabel from './common/CircularProgressWithLabel';

const Rotate = keyframes`
  0% {
    -webkit-transform: rotate(0deg) scale(0.8);
    -moz-transform: rotate(0deg) scale(0.8);
  }
  50% {
    -webkit-transform: rotate(360deg) scale(1.2);
    -moz-transform: rotate(360deg) scale(1.2);
  }
  100% {
    -webkit-transform: rotate(720deg) scale(0.8);
    -moz-transform: rotate(720deg) scale(0.8);
  }
`;

const Ball1 = keyframes`
  0% {
    box-shadow: 30px 0 0 #FFBE2D;
  }
  50% {
    box-shadow: 0 0 0 #FFBE2D;
    margin-bottom: 0;
    -webkit-transform: translate(15px,15px);
    -moz-transform: translate(15px, 15px);
  }
  100% {
    box-shadow: 30px 0 0 #FFBE2D;
    margin-bottom: 10px;
  }
`;

const Ball2 = keyframes`
  0% {
    box-shadow: 30px 0 0 #5AD797;
  }
  50% {
    box-shadow: 0 0 0 #5AD797;
    margin-top: -20px;
    -webkit-transform: translate(15px,15px);
    -moz-transform: translate(15px, 15px);
  }
  100% {
    box-shadow: 30px 0 0 #5AD797;
    margin-top: 0;
  }
`;

const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const LoaderContainer = styled.div`
  width: 100%;
  margin-top: 20vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LoaderOverlay = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 100;
`;

const LoadingSpinner = styled.div`
  animation: ${Rotate} 1s infinite;
  height: 50px;
  width: 50px;
  &::before {
    border-radius: 50%;
    content: '';
    display: block;
    height: 20px;
    width: 20px;
    animation: ${Ball1} 1s infinite;
    background-color: #ff5f57;
    box-shadow: 30px 0 0 #ffbe2d;
    margin-bottom: 10px;
  }
  &::after {
    border-radius: 50%;
    content: '';
    display: block;
    height: 20px;
    width: 20px;
    animation: ${Ball2} 1s infinite;
    background-color: #558dff;
    box-shadow: 30px 0 0 #5ad797;
  }
`;

export const Loader = () => (
  <LoadingWrapper>
    <LoadingSpinner />
  </LoadingWrapper>
);

export const LoadSpinner = ({ style }) => {
  return (
    <LoaderContainer style={{ ...style }}>
      <LoadingSpinner />
    </LoaderContainer>
  );
};

export const LoadSpinnerOverlay = ({ style }) => {
  return (
    <LoaderOverlay style={{ ...style }}>
      <LoadingSpinner />
    </LoaderOverlay>
  );
};

export const ProgressLoadSpinnerOverlay = ({
  style,
  progressMsg = 'Update in progress ....',
  percentage = 0
}) => {
  return (
    <LoaderOverlay style={{ ...style }}>
      <div
        style={{
          fontSize: '12px',
          fontWeight: '500',
          fontStyle: 'italic',
          display: 'flex',
          marginRight: 10
        }}
      >
        <CircularProgressWithLabel value={percentage} />
        <div style={{ margin: 'auto 5px' }}>{progressMsg}</div>
      </div>
    </LoaderOverlay>
  );
};
